export const StorageKeys = {
  hasSeenOnboarding: "hasSeenOnboarding",
  currentUser: "currentUser",
  appVersion: "appVersion",
} as const;
